import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=350f8f2b&scoped=true&"
import script from "./relation.vue?vue&type=script&lang=js&"
export * from "./relation.vue?vue&type=script&lang=js&"
import style0 from "./relation.vue?vue&type=style&index=0&id=350f8f2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f8f2b",
  null
  
)

export default component.exports